module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[83]326.acc3a50.woff2";